import { RetailerTranslations } from "@narvar/nth-hook-loma";
import { RetailerThemeStyles } from "@narvar/nth-hook-theme";

export const themeTokens: (keyof RetailerThemeStyles)[] = [
  "panelcontainerNoneNone",
  "selecteditemNoneNone",
  "buttonsPrimaryDefault",
  "buttonsSecondaryDefault",
  "bodytextDefaultNone",
  "documentbodyNoneNone",
];

export const translationKeys: (keyof RetailerTranslations)[] = [
  "returnsReasonsItemInfoTitle",
  "returnsReasonsItemInfoColor",
  "returnsReasonsItemInfoColorLabel",
  "returnsReasonsItemInfoSize",
  "returnsReasonsItemInfoSizeLabel",
  "returnsReasonsItemInfoQuantity",
  "returnsReasonsItemInfoQuantityLabel",
  "returnsReasonsItemInfoQuantitySelectPlaceholder",
  "returnsReasonsListTitle",
  "returnsReasonsListTitleSecondary",
  "returnsReasonsCommentsTitle",
  "returnsReasonsCommentsPlaceholder",
  "returnsReasonsEditTitle",
  "returnsReasonsEditRemoveLabel",
  "returnsReasonsEditContinueLabel",
  "returnsReasonsQuantityAllTitle",
  "returnsReasonsQuantityAllTitleHipaa",
  "returnsReasonsQuantityAllYesLabel",
  "returnsReasonsQuantityAllNoLabel",
  "returnsReasonsQuantityAllError",
  "returnsReasonsQuantityTitle",
  "returnsActionsNext",
];
